import { useQuery } from "@tanstack/react-query";
import { getMobilityCheck } from "../api/mobility";
import { GetMobilityCheck } from "../types/types";
import userStorage from "../utils/userStorage";

// 점검 대상 농기기 조회 - 호출 주기 60분
const useGetMobilityCheck = (params: GetMobilityCheck) => {
  const user = userStorage.get();

  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [
      "MobilityCheck",
      `limit-${params.limit}`,
      `page-${params.page}`,
    ],
    queryFn: () => getMobilityCheck(params),
    retry: false,
    refetchInterval: 1000 * 60 * 60, // 1시간마다 재요청
    refetchOnWindowFocus: false, // 윈도우 포커스시 재요청 X
    refetchOnMount: false, // 컴포넌트 마운트 시 재요청 X
    refetchOnReconnect: false, // 네트워크 재연결 시 재요청 X
    staleTime: 1000 * 60 * 60, // 데이터를 1시간 동안 fresh로 간주
    enabled: !!user,
  });

  return { data, isLoading, isSuccess };
};

export default useGetMobilityCheck;
